import { createSlice } from "@reduxjs/toolkit";

/**
 * Fungsi hanya increment saja untuk trigger use effect agar reload data
 * Listener FCM hanya ada 1 di index dashboard, agar tidak ribet passing data, pakai redux
 */

export const chatUpdate = createSlice({
  name: "chat_update",
  initialState: {
    value: 0,
  },
  reducers: {
    updateChat: (state) => {
      state.value += 1;
    },
  },
});

export const { updateChat } = chatUpdate.actions;

export default chatUpdate.reducer;
